import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000';

const getAuthHeaders = () => {
  const token = localStorage.getItem("clerkToken");
  return {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
};

export const fetchPrivateListings = ({
  make,
  sort_by,
  sort_order,
  limit,
  offset,
}) =>
  axios
    .get(`${BASE_URL}/private-listings/listings`, {
      headers: getAuthHeaders(),
      params: {
        make,
        sort_by,
        sort_order,
        limit,
        offset,
      },
    })
    .then((res) => res.data);

// Add makes API
export const fetchMakes = () =>
  axios
    .get(`${BASE_URL}/private-listings/makes`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data.makes || []);

// Fetch insights data for a specific listing
export const fetchListingInsights = (listingId) =>
  axios
    .get(`${BASE_URL}/private-listings/insights/${listingId}`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);

export const fetchMarketplaceTaskStatus = () =>
  axios
    .get(`${BASE_URL}/dealership/marketplace-task-status`, {
      headers: getAuthHeaders(),
    })
    .then((res) => res.data);